<ngx-chart-kpi [data]="emptyData" [wide]="wide"></ngx-chart-kpi>
